import { FiImage, FiCamera, FiFilm, FiMusic } from "react-icons/fi";

// Must match EXTENSIONS in face_recognition_ml/classes/transfer_controller.py
const KINDS = {
  image: ["jpg", "jpeg", "png", "heic", "heif", "tif", "tiff", "webp"],
  raw: ["cr2", "cr3", "nef", "arw", "dng", "raf", "orf", "rw2", "pef", "srw"],
  video: ["mp4", "mov", "m4v", "avi", "mkv", "mts", "m2ts"],
  audio: ["mp3", "wav", "aac", "m4a", "flac", "aiff", "ogg"],
};

const EXT_TO_KIND = Object.fromEntries(
  Object.entries(KINDS).flatMap(([kind, exts]) => exts.map((e) => [e, kind]))
);

export const KIND_ICONS = { image: FiImage, raw: FiCamera, video: FiFilm, audio: FiMusic };

export const fileExt = (name) => (name.includes(".") ? name.split(".").pop().toLowerCase() : "");

export const fileKind = (name) => EXT_TO_KIND[fileExt(name)] || null;

export const isAllowedFile = (file) => fileKind(file.name) !== null;

export const ALLOWED_EXTENSIONS = Object.keys(EXT_TO_KIND).map((e) => `.${e}`);

export function formatBytes(bytes) {
  if (!bytes) return "0 B";
  const units = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
  const value = bytes / 1024 ** i;
  return `${value >= 100 || i === 0 ? Math.round(value) : value.toFixed(1)} ${units[i]}`;
}

export const GB = 1024 ** 3;
